/**
 * Created with JetBrains WebStorm.
 * User: vanessasoc
 * Date: 12/03/19
 * Time: 15:45
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
factory('ServiceSettingsReserveWithGoogle_Resource',["$resource","$location", function ($resource,$location)
{
    let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
    return  $resource( baseUrl + 'rest/reserve-with-google/settings/services' , {} ,
        {
            get:   { method: 'GET', url: baseUrl + 'rest/reserve-with-google/settings/services/:id'},
            save:   { method: 'PUT', url: baseUrl + 'rest/reserve-with-google/settings/services/:id'},
            create:   { method: 'POST', url: baseUrl + 'rest/reserve-with-google/settings/services/:id'}
        }
    );
}]);
angular.module('FlexyBeautyApp.services').
factory('ServiceSettingsReserveWithGoogle',["ServiceSettingsReserveWithGoogle_Resource","ServiceSettingsReserveWithGoogleData",
    function (ServiceSettingsReserveWithGoogle_Resource,ServiceSettingsReserveWithGoogleData)
    {
        let ServiceSettingsReserveWithGoogle = function (resource,serviceSettingsReserveWithGoogleId)
        {
            this.serviceSettingsReserveWithGoogleId = serviceSettingsReserveWithGoogleId;
            this.enabled = false;//Default;
            this.priceEnabled = false;//Default;
            this.price = 0;
            this.description= "";
            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource);
            }
            if(serviceSettingsReserveWithGoogleId){
                ServiceSettingsReserveWithGoogleData.add(this);
            }
        };
        ServiceSettingsReserveWithGoogle.prototype.loadObject = function(object)
        {
            if (!this.serviceSettingsReserveWithGoogleId)
                this.serviceSettingsReserveWithGoogleId = object.serviceSettingsReserveWithGoogleId;
            this.enabled = object.enabled;
            this.priceEnabled = object.priceEnabled;
            this.price= object.price;
            this.description= object.description;
        };
        ServiceSettingsReserveWithGoogle.prototype.getObjectResource = function()
        {
            let rsServiceSettingsReserveWithGoogle = new ServiceSettingsReserveWithGoogle_Resource();
            rsServiceSettingsReserveWithGoogle.enabled = this.enabled;
            rsServiceSettingsReserveWithGoogle.priceEnabled = this.priceEnabled;
            rsServiceSettingsReserveWithGoogle.price = this.price;
            rsServiceSettingsReserveWithGoogle.description = this.description;
            return rsServiceSettingsReserveWithGoogle;
        };
        return ServiceSettingsReserveWithGoogle;
    }
]);
angular.module('FlexyBeautyApp.services').
factory('ServiceSettingsReserveWithGoogleSrv',["ServiceSettingsReserveWithGoogle_Resource","ServiceSettingsReserveWithGoogle",
    function (ServiceSettingsReserveWithGoogle_Resource,ServiceSettingsReserveWithGoogle) {
        let ServiceSettingsReserveWithGoogleSrv = {};
        ServiceSettingsReserveWithGoogleSrv.get = function (serviceSettingsReserveWithGoogleId,successFunction, errorFunction) {
            if (serviceSettingsReserveWithGoogleId) {
                let serviceSettingReserveWithGoogleResource = new ServiceSettingsReserveWithGoogle_Resource();
                serviceSettingReserveWithGoogleResource.$get(
                    {id: serviceSettingsReserveWithGoogleId}, //params
                    function (serviceSettingsReserveWithGoogle) {
                        if (successFunction)
                            successFunction(new ServiceSettingsReserveWithGoogle(serviceSettingsReserveWithGoogle,serviceSettingsReserveWithGoogleId));
                    },
                    function (serviceSettingsReserveWithGoogle) {
                        if (errorFunction)
                            errorFunction();
                    });
            }else{
                if (errorFunction!== undefined)
                    errorFunction();
            }
        };
        ServiceSettingsReserveWithGoogleSrv.save = function (serviceSettingsReserveWithGoogle,successFunction, errorFunction) {
            if (serviceSettingsReserveWithGoogle) {
                let serviceSettingReserveWithGoogleResource = serviceSettingsReserveWithGoogle.getObjectResource();
                serviceSettingReserveWithGoogleResource.$save(
                    {id: serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId}, //params
                    function () {
                        if (successFunction)
                            successFunction();
                    },
                    function () {
                        if (errorFunction)
                            errorFunction();
                    });
            }else{
                if (errorFunction!== undefined)
                    errorFunction();
            }
        };
        ServiceSettingsReserveWithGoogleSrv.create = function (serviceSettingsReserveWithGoogle,serviceId,successFunction, errorFunction) {
            if (serviceSettingsReserveWithGoogle) {
                let serviceSettingsReserveWithGoogleResource = serviceSettingsReserveWithGoogle.getObjectResource();
                serviceSettingsReserveWithGoogleResource.$create(
                    {id: serviceId}, //params
                    function (data) {
                        if (successFunction)
                            successFunction(data);
                    },
                    function () {
                        if (errorFunction)
                            errorFunction();
                    });
            }else{
                if (errorFunction!== undefined)
                    errorFunction();
            }
        };
        return ServiceSettingsReserveWithGoogleSrv;
    }]);
angular.module('FlexyBeautyApp.services').
factory('ServiceSettingsReserveWithGoogleData',["$log", function ($log)
{
    let  serviceSettingsReserveWithGoogleData =
        {
            serviceSettingsReserveWithGoogle : []
        };
    serviceSettingsReserveWithGoogleData.getById =  function(serviceSettingsReserveWithGoogleId)
    {
        for (let i=0;i<this.serviceSettingsReserveWithGoogle.length;i++)
            if (this.serviceSettingsReserveWithGoogle[i].serviceSettingsReserveWithGoogleId==serviceSettingsReserveWithGoogleId)
                return this.serviceSettingsReserveWithGoogle[i];
        return null;
    };
    serviceSettingsReserveWithGoogleData.getIndexOf =  function(serviceSettingsReserveWithGoogle)
    {
        if (serviceSettingsReserveWithGoogle)
            return this.serviceSettingsReserveWithGoogle.indexOf(serviceSettingsReserveWithGoogle);
        return -1;
    };
    serviceSettingsReserveWithGoogleData.add = function(serviceSettingsReserveWithGoogle)
    {
        if(serviceSettingsReserveWithGoogleData.getById(serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId)){
            this.serviceSettingsReserveWithGoogle.splice( serviceSettingsReserveWithGoogleData.getById(serviceSettingsReserveWithGoogle.serviceSettingsReserveWithGoogleId),1, serviceSettingsReserveWithGoogle);
        }
        else{
            this.serviceSettingsReserveWithGoogle.push(serviceSettingsReserveWithGoogle);
        }
        return this.serviceSettingsReserveWithGoogle[serviceSettingsReserveWithGoogleData.getIndexOf(serviceSettingsReserveWithGoogle)];
    };
    return serviceSettingsReserveWithGoogleData;
}
]);


// WEBPACK FOOTER //
// ./js/services/models/ServiceSettingsReserveWithGoogle.js